import React, { useEffect, useState } from "react";
import SearchBar from "../../components/searchBar/SearchBar";
import BackButtonSettings from "../../components/settingBackButton";
import ChannelManager from "./channelManager";
import UserInterface from "./userInterface";
import AccountAndSecurity from "./account&Security";
import AlertAndNotification from "./alert&Notification";
import ReportScheduling from "./reportScheduling";
import MyProperties from "./myProperties";
import UserManagement from "./userManagement";
import SettingsRateSuggestions from "./rateSuggestions";
import PropertyManagement from "./propertyManagement";
import RoomMapping from "./roomMapping";
import { useLocation, useNavigate } from "react-router-dom";
import SwitchProperty from "./switchProperty";
import { CurrentProperty } from "../../utils/impVars";
import profile from "../../assets/icons/3.svg";
import arrow from "../../assets/icons/Vector (4).svg";
import arrowup from "../../assets/icons/Vector up.svg";
import arrow1 from "../../assets/icons/Vector (3).svg";
import { Tooltip } from "react-tooltip";

const scrollbarStyles = `
    ::-webkit-scrollbar {
        width: 0.8em;
    }

    ::-webkit-scrollbar-thumb {
        background-color: transparent;
    }

    * {
        scrollbar-width: thin;
        scrollbar-color: transparent transparent;
    }
`;

const Settings = () => {
  const navigate = useNavigate();
  const loaction = useLocation();
  const propId = CurrentProperty();
  const [isDropdownOpen, setIsDropDown] = useState(false);

  const [selectedItem, setSelectedItem] = useState("account_&_security"); // Default selected item
  const handleItemClick = (item) => {
    setSelectedItem(item);
  };

  const handleBackButtonClick = () => {
    navigate("/");
  };

  useEffect(() => {
    if (loaction?.state?.address) {
      setSelectedItem(loaction?.state?.address?.case1);
    }
  }, [loaction?.state?.address]);
  const formatName = (name) => {
    // Convert the name to camel case (e.g., first_item to First Item)
    const words = name
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1));
    return words.join(" ");
  };

  const propertiesList = window.localStorage.getItem("propertiesList")
    ? JSON.parse(window.localStorage.getItem("propertiesList")) || []
    : [];
  const selectedProperty =
    propertiesList &&
    propertiesList?.filter((prop) => {
      return parseInt(prop?.propertyId) === parseInt(propId);
    });

  console.log(propertiesList, "PropList");
  const handleSwitchProperty = (items) => {
    window.localStorage.setItem("hId", items?.propertyId);
    window.localStorage.setItem("adminHid", items?.propertyId);
    window.location.reload();
  };

  const moreProperty =
    propertiesList &&
    propertiesList?.filter((prop) => {
      return parseInt(prop?.propertyId) != parseInt(propId);
    });

    const toggleDropdown = () => {
      // setDropdownVisible(null)
      setIsDropDown(!isDropdownOpen);
    };

  const renderContent = () => {
    switch (selectedItem) {
      case "account_&_security":
        return (
          <div>
            <AccountAndSecurity />
          </div>
        );
      case "user_interface":
        return (
          <div>
            <UserInterface />
          </div>
        );
      case "alert_&_notification":
        return (
          <div>
            <AlertAndNotification />
          </div>
        );
      case "report_scheduling":
        return (
          <div>
            <ReportScheduling />
          </div>
        );
      case "my_properties":
        return (
          <div>
            <MyProperties />
          </div>
        );
      case "property_management":
        return (
          <div>
            <PropertyManagement />
          </div>
        );
      case "room_mapping":
        return (
          <div>
            <RoomMapping />
          </div>
        );
      case "user_management":
        return (
          <div>
            <UserManagement />
          </div>
        );
      case "dynamic_pricing":
        return (
          <div>
            <SettingsRateSuggestions />
          </div>
        );
      case "channel_manager":
        return (
          <div>
            {" "}
            <ChannelManager />
          </div>
        );
      case "switch_property":
        return (
          <div>
            {" "}
            <SwitchProperty />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <style>{scrollbarStyles}</style>
      <div className="p-6 ">
        <div className="flex flex-col gap-4 w-[100%]">
          <div className="flex items-center justify-start w-[28%]">
            <div className="flex items-center  gap-2">
              {/* <BackButtonSettings
                handleBackButtonClick={handleBackButtonClick}
              /> */}
              <p className=" text-[#ffffff] dark:text-black text-[21px] ml-4">
                Settings
              </p>
            </div>
            <div></div>
          </div>

          <div className="flex h-[77vh] w-[100%] gap-2">
            <div
              className={`w-[276px] flex bg-newGradient rounded-lg flex-col gap-2 dark:bg-lightGradient `}
              style={{ maxHeight: "100%", overflowY: "auto" }}
            >
              <div
                className="overflow-y-auto
               
                h-full rounded-xl"
              >
                <ul className="space-y-2 text-[14px] p-2">
                  <li>
                    <a
                      href="#"
                      className={`flex items-center p-2 hover:bg-[#1d2d44b6] hover:text-[#FFFFFF] rounded-lg ${
                        selectedItem === "account_&_security"
                          ? "text-[#ffffff] bg-[#1d2d44b6] "
                          : " text-white"
                      }`}
                      onClick={() => handleItemClick("account_&_security")}
                    >
                      <Icon />
                      <span className="ml-2  text-[14px]">
                        Account & Security
                      </span>
                    </a>
                  </li>
                  {/* <li>
                    <a
                      href="#"
                      className={`flex items-center p-2  rounded-lg hover:bg-[#1d2d44b6] hover:text-[#FFFFFF]  ${
                        selectedItem === "user_interface"
                          ? "text-[#081439]"
                          : "text-[#59647B]"
                      }`}
                      onClick={() => handleItemClick("user_interface")}
                    >
                      <Icon />
                      <span className="ml-2 text-[14px]">User Interface</span>
                    </a>
                  </li> */}
                  <li>
                    <a
                      href="#"
                      className={`flex items-center p-2  rounded-lg hover:bg-[#1d2d44b6] hover:text-[#FFFFFF]  ${
                        selectedItem === "alert_&_notification"
                          ? "text-[#ffffff] bg-[#1d2d44b6]"
                          : " text-white"
                      }`}
                      onClick={() => handleItemClick("alert_&_notification")}
                    >
                      <Icon />
                      <span className="ml-2 text-[14px]">
                        Alerts & Notification
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className={`flex items-center p-2  rounded-lg hover:bg-[#1d2d44b6] hover:text-[#FFFFFF]  ${
                        selectedItem === "report_scheduling"
                          ? "text-[#ffffff] bg-[#1d2d44b6]"
                          : "text-white"
                      }`}
                      onClick={() => handleItemClick("report_scheduling")}
                    >
                      <Icon />
                      <span className="ml-2 text-[14px]">
                        Report Scheduling
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className={`flex items-center p-2  rounded-lg hover:bg-[#1d2d44b6] hover:text-[#FFFFFF]  ${
                        selectedItem === "property_management"
                          ? "text-[#ffffff] bg-[#1d2d44b6]"
                          : "text-white"
                      }`}
                      onClick={() => handleItemClick("property_management")}
                    >
                      <Icon />
                      <span className="ml-2 text-[14px]">
                        Property Management
                      </span>
                    </a>
                  </li>
                  {/* <li>
                    <a
                      href="#"
                      className={`flex items-center p-2  rounded-lg hover:bg-[#1d2d44b6] hover:text-[#FFFFFF]  ${
                        selectedItem === "room_mapping"
                          ? "text-[#081439]"
                          : "text-[#59647B]"
                      }`}
                      onClick={() => handleItemClick("room_mapping")}
                    >
                      <Icon />
                      <span className="ml-2 text-[14px]">Room Mapping</span>
                    </a>
                  </li> */}
                  <li>
                    <a
                      href="#"
                      className={`flex items-center p-2  rounded-lg hover:bg-[#1d2d44b6] hover:text-[#FFFFFF]  ${
                        selectedItem === "my_properties"
                          ? "text-[#ffffff] bg-[#1d2d44b6]"
                          : "text-white"
                      }`}
                      onClick={() => handleItemClick("my_properties")}
                    >
                      <Icon />
                      <span className="ml-2 text-[14px]">
                        Compsets Management
                      </span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className={`flex items-center p-2 rounded-lg hover:bg-[#1d2d44b6] hover:text-[#FFFFFF]  ${
                        selectedItem === "user_management"
                          ? "text-[#ffffff] bg-[#1d2d44b6]"
                          : "text-white"
                      }`}
                      onClick={() => handleItemClick("user_management")}
                    >
                      <Icon />
                      <span className="ml-2 text-[14px]">User Management</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className={`flex items-center p-2 rounded-lg hover:bg-[#1d2d44b6] hover:text-[#FFFFFF]  ${
                        selectedItem === "dynamic_pricing"
                          ? "text-[#ffffff] bg-[#1d2d44b6]"
                          : "text-white"
                      }`}
                      onClick={() => handleItemClick("dynamic_pricing")}
                    >
                      <Icon />
                      <span className="ml-2 text-[14px]">Dynamic Pricing</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="#"
                      className={`flex items-center p-2 rounded-lg hover:bg-[#1d2d44b6] hover:text-[#FFFFFF]  ${
                        selectedItem === "channel_manager"
                          ? "text-[#ffffff] bg-[#1d2d44b6]"
                          : "text-white"
                      }`}
                      onClick={() => handleItemClick("channel_manager")}
                    >
                      <Icon />
                      <span className="ml-2 text-[14px]">Channel Manager</span>
                    </a>
                  </li>
                </ul>
                <div className="relative">
                  <div onClick={toggleDropdown} className="mx-4 my-2 cursor-pointer p-2 flex justify-between items-center rounded-lg text-black bg-gray-200 text-sm">
                    <div className="w-14">
                      <img
                        src={profile}
                        alt="Profile"
                        className="object-cover"
                        style={{ width: "60%" }}
                      />
                    </div>
                    <div className="text-nowrap max-w-[220px] text-sm -ml-3 truncate text-start">
                      {selectedProperty &&
                        Array.isArray(selectedProperty) &&
                        selectedProperty[0]?.propertyName}
                    </div>
                    <div className="cursor-pointer w-auto p-2 flex items-center">
                      <img
                        className="w-4 hoverEffect"
                        src={isDropdownOpen ? arrowup : arrow}
                        alt=""
                      />
                    </div>
                  </div>
                {isDropdownOpen &&  <div  className="rounded-lg mx-4 bg-gray-50 max-h-[120px] overflow-y-scroll">
                    {Array.isArray(moreProperty) &&
                      moreProperty?.map((prop) => {
                        return (
                          <div onClick={()=>handleSwitchProperty(prop)} className="flex items-center hover:bg-gray-200 justify-between">
                            {" "}
                            <div data-tooltip-id={prop?.propertyName} data-tooltip-content={prop?.propertyName} className="text-sm px-4 py-2 cursor-pointer  max-w-[200px] truncate">
                              {prop?.propertyName}
                              <Tooltip place="top" id={prop?.propertyName} />
                            </div>{" "}
                            <div className="cursor-pointer w-auto p-2 flex items-center">
                              <img
                                className="hoverEffect"
                                src={arrow1}
                                alt=""
                                width={8}
                              />
                            </div>
                          </div>
                        );
                      })}
                  </div>}
                </div>
              </div>
            </div>
            <div
              className={``}
              style={{
                width: "calc(100% - 276px)",
                maxHeight: "100%",
                overflow: "auto",
              }}
            >
              <div style={{ maxHeight: "100%", height: "100%" }}>
                {renderContent()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings;

const Icon = () => {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.899 1.79386C11.5904 1.66699 11.1991 1.66699 10.4167 1.66699C9.63418 1.66699 9.24294 1.66699 8.93433 1.79386C8.52284 1.96302 8.19591 2.28747 8.02546 2.69585C7.94766 2.88228 7.91721 3.09908 7.90529 3.41532C7.88778 3.88006 7.64763 4.31024 7.2418 4.54277C6.83598 4.7753 6.34053 4.76661 5.92624 4.54929C5.64432 4.40141 5.43991 4.31918 5.23832 4.29284C4.79674 4.23514 4.35015 4.3539 3.9968 4.62299C3.73178 4.82481 3.53616 5.16107 3.14492 5.8336C2.75368 6.50613 2.55806 6.84239 2.51446 7.17108C2.45632 7.60933 2.57598 8.05254 2.84712 8.40323C2.97088 8.56329 3.14481 8.69785 3.41475 8.86618C3.8116 9.11365 4.06693 9.53521 4.06691 10.0003C4.06688 10.4654 3.81155 10.8869 3.41475 11.1344C3.14476 11.3027 2.97081 11.4373 2.84704 11.5974C2.5759 11.9481 2.45624 12.3913 2.51437 12.8295C2.55798 13.1582 2.7536 13.4945 3.14484 14.167C3.53608 14.8395 3.7317 15.1758 3.99671 15.3776C4.35007 15.6467 4.79666 15.7655 5.23824 15.7078C5.43981 15.6814 5.64421 15.5992 5.92611 15.4513C6.34043 15.234 6.83592 15.2253 7.24177 15.4579C7.64762 15.6904 7.88778 16.1206 7.90529 16.5854C7.91721 16.9016 7.94766 17.1184 8.02546 17.3048C8.19591 17.7132 8.52284 18.0376 8.93433 18.2068C9.24294 18.3337 9.63418 18.3337 10.4167 18.3337C11.1991 18.3337 11.5904 18.3337 11.899 18.2068C12.3105 18.0376 12.6374 17.7132 12.8079 17.3048C12.8857 17.1184 12.9161 16.9016 12.928 16.5853C12.9456 16.1206 13.1857 15.6904 13.5915 15.4579C13.9973 15.2253 14.4928 15.234 14.9072 15.4513C15.1891 15.5991 15.3934 15.6814 15.595 15.7077C16.0366 15.7654 16.4832 15.6466 16.8365 15.3775C17.1016 15.1757 17.2972 14.8395 17.6884 14.1669C18.0797 13.4944 18.2753 13.1581 18.3189 12.8295C18.377 12.3912 18.2573 11.948 17.9862 11.5973C17.8624 11.4372 17.6885 11.3027 17.4185 11.1343C17.0217 10.8869 16.7664 10.4654 16.7664 10.0003C16.7664 9.5352 17.0218 9.11373 17.4185 8.86632C17.6885 8.69795 17.8625 8.56337 17.9863 8.40328C18.2574 8.0526 18.3771 7.60938 18.319 7.17114C18.2754 6.84245 18.0797 6.50619 17.6885 5.83366C17.2973 5.16113 17.1016 4.82487 16.8366 4.62305C16.4833 4.35396 16.0367 4.2352 15.5951 4.2929C15.3935 4.31923 15.1891 4.40146 14.9072 4.54932C14.4929 4.76665 13.9974 4.77534 13.5916 4.54279C13.1857 4.31025 12.9456 3.88004 12.928 3.41527C12.9161 3.09906 12.8857 2.88227 12.8079 2.69585C12.6374 2.28747 12.3105 1.96302 11.899 1.79386Z"
          fill="#424E61"
        />
        <path
          d="M12.9365 10C12.9365 11.3807 11.8087 12.5 10.4175 12.5C9.02625 12.5 7.89844 11.3807 7.89844 10C7.89844 8.61929 9.02625 7.5 10.4175 7.5C11.8087 7.5 12.9365 8.61929 12.9365 10Z"
          fill="white"
        />
      </svg>
    </>
  );
};
